/**
 * API de wallet usando Axios.
 */
import { axiosInstance } from "features/shared/api";
import type { ResolvedAddressesDto, WalletExistsDto } from "common/models";

export const walletApi = {
    existsByAddressOrEmail: (addressOrEmail: string, organizationAddress: string) =>
        axiosInstance
            .get<WalletExistsDto>("/api/wallets/exists", {
                params: { addressOrEmail, organizationAddress },
            })
            .then((r) => r.data),

    resolveAddresses: (addresses: string[]) =>
        axiosInstance
            .get<ResolvedAddressesDto>("/api/wallets/resolve-addresses", {
                params: { addresses: addresses.join(",") },
            })
            .then((r) => r.data),
};
